<template>
    <div
        class="flex overflow-hidden relative flex-col rounded-xl"
        :class="[
            {
                'shadow-md': this.shadow,
            }
        ]"
    >
        <div v-if="showLower" class="absolute bottom-0 w-full h-1/2 bg-linear-to-r from-secondary-900 to-secondary-800" />
        <div class="flex relative grow w-full rounded-xl" :class="contentWrapperClass" :data-test="dataTest(type)">
            <div
                v-if="showOverlay"
                class="flex absolute inset-0 zi-10 justify-center items-center w-full h-full"
                :class="isDone ? 'bg-brand-sushi/50' : 'bg-gray-600/25 cursor-not-allowed'"
            >
                <base-icon v-if="isDone" class="text-white h-40" name="check" />
            </div>
            <div
                class="max-w-full"
                :class="contentClass"
            >
                <slot />
            </div>
        </div>
        <div v-if="showLower" class="zi-0 p-1">
            <slot name="lower-plate" />
        </div>
    </div>
</template>

<script>
export default {
    name:     'BlockContainer',
    props:    {
        type:         {
            type:     String,
            required: false,
            default:  'active',
            validator(type) {
                return ['active', 'done', 'disabled'].indexOf(type) !== -1;
            },
        },
        padding:      {
            type:    String,
            default: 'p-4',
        },
        contentClass: {
            type:    String,
            default: 'flex-1',
        },
        shadow:       {
            type:    Boolean,
            default: true,
        },
        background:   {
            type:    Boolean,
            default: true,
        },
    },
    computed: {
        isActive() {
            return this.type === 'active';
        },
        isDone() {
            return this.type === 'done';
        },
        contentWrapperClass() {
            return {
                [this.padding]: true,
                'bg-white':     this.background,
                'shadow-lg':    this.showLower,
            };
        },
        showOverlay() {
            return this.type === 'done' || this.type === 'disabled';
        },
        showLower() {
            return !!this.$slots['lower-plate'] && this.$slots['lower-plate'].length && this.isActive;
        },
    },
};
</script>
